'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosAnalyticsOutline = function IoIosAnalyticsOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 3.8c-2.2 0-4.3 0.3-6.3 1.2-2 0.8-3.7 2-5.2 3.5s-2.7 3.2-3.5 5.2c-0.9 2-1.2 4.1-1.2 6.3s0.3 4.3 1.2 6.3c0.8 2 2 3.7 3.5 5.2s3.2 2.7 5.2 3.5c2 0.9 4.1 1.3 6.3 1.3s4.3-0.4 6.3-1.3c2-0.8 3.7-2 5.2-3.5s2.7-3.2 3.5-5.2c0.9-2 1.3-4.1 1.3-6.3s-0.4-4.3-1.3-6.3c-0.8-2-2-3.7-3.5-5.2s-3.2-2.7-5.2-3.5c-2-0.9-4.1-1.2-6.3-1.2z m0-1.3c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m-11.6 22.5c-1.9 0-3.2-1.4-3.2-1.5-0.3-0.2-0.2-0.7 0-0.9s0.7-0.2 0.9 0.1c0.1 0 1.2 1.3 2.8 1.1 0.9-0.2 2.1-2.1 3-3.3 0.3-0.5 0.7-1 0.9-1.3 1.3-1.6 2.7-1.8 3.5-1.6 1.9 0.2 3.5 2.2 4.3 3.9 0.5 1.4 1.4 2.2 2.5 2.3 1.1 0 2.4-0.9 3.3-2.4 0.1-0.1 0.2-0.3 0.3-0.5 0.7-1.4 1.9-3.4 4.1-3.4 2.4 0 4 2.7 4.1 2.8 0.2 0.3 0.1 0.7-0.2 0.9s-0.7 0-0.9-0.3c0 0-0.4-0.6-0.9-1.1-0.5-0.5-1.3-1.1-2.1-1.1-1.4 0-2.3 1.5-3 2.8-0.1 0.2-0.2 0.4-0.3 0.5-1.2 2-2.8 3.2-4.5 3-1.6-0.1-2.8-1.2-3.6-3s-2.2-3.1-3.2-3.3c-0.9 0-1.7 0.4-2.4 1.3-0.3 0.3-0.5 0.7-0.8 1.2-1.1 1.5-2.4 3.5-3.9 3.7-0.3 0-0.4 0.1-0.7 0.1z' })
        )
    );
};

exports.default = IoIosAnalyticsOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-analytics-outline.js
// module id = 2543
// module chunks = 168707334958949